// Mock data for NextGen Crowdfunding Platform

// Campaign Categories - For personal causes, emergencies, charitable fundraising
export const categories = [
  { 
    id: 'medical', name: 'Medical & Health', icon: 'Heart', 
    description: 'Treatments, surgeries, therapy, hospital bills', color: '#ef4444',
    subcategories: ['Cancer Treatment', 'Chronic Illness', 'Dental Care', 'Disability Support', 'Heart Disease', 'Hospital Bills', 'Medical Equipment', 'Medications', 'Mental Health', 'Organ Transplant', 'Physical Therapy', 'Pregnancy Care', 'Rare Disease', 'Rehabilitation', 'Surgery', 'Vision Care']
  },
  { 
    id: 'emergency', name: 'Emergency & Crisis', icon: 'AlertTriangle', 
    description: 'Natural disasters, accidents, urgent needs', color: '#f97316',
    subcategories: ['Accident Recovery', 'Car Accident', 'Crisis Relief', 'Earthquake', 'Emergency Housing', 'Evacuation', 'Fire Recovery', 'Flood Relief', 'Hurricane Relief', 'Natural Disaster', 'Robbery/Theft', 'Storm Damage', 'Urgent Need', 'War/Conflict Relief']
  },
  { 
    id: 'education', name: 'Education & Learning', icon: 'GraduationCap', 
    description: 'Tuition, scholarships, school supplies', color: '#3b82f6',
    subcategories: ['Books & Materials', 'College Tuition', 'Coding Bootcamp', 'Graduate School', 'High School', 'Language Learning', 'Online Courses', 'Professional Certification', 'Scholarships', 'School Supplies', 'Special Education', 'Study Abroad', 'Technical Training', 'Tutoring', 'Vocational Training']
  },
  { 
    id: 'memorial', name: 'Memorial & Funeral', icon: 'Heart', 
    description: 'Funeral costs, memorial funds, tributes', color: '#6b7280',
    subcategories: ['Burial Costs', 'Cemetery Costs', 'Cremation', 'Funeral Expenses', 'Headstone/Monument', 'Legacy Project', 'Memorial Fund', 'Memorial Service', 'Repatriation', 'Tribute']
  },
  { 
    id: 'animals', name: 'Animals & Pets', icon: 'Heart', 
    description: 'Vet bills, animal rescue, shelters', color: '#84cc16',
    subcategories: ['Animal Rescue', 'Animal Shelter', 'Emergency Vet Care', 'Farm Animals', 'Pet Adoption', 'Pet Food/Supplies', 'Pet Medications', 'Pet Surgery', 'Service Animals', 'Veterinary Bills', 'Wildlife Conservation', 'Wildlife Rehabilitation']
  },
  { 
    id: 'community', name: 'Community', icon: 'Users', 
    description: 'Local initiatives, neighborhood projects', color: '#14b8a6',
    subcategories: ['After-School Program', 'Clean-up Initiative', 'Community Center', 'Community Garden', 'Food Bank', 'Homeless Support', 'Library Project', 'Local Business', 'Neighborhood Project', 'Park Improvement', 'Public Space', 'Senior Support', 'Youth Program']
  },
  { 
    id: 'nonprofit', name: 'Non-Profit & Charity', icon: 'Building2', 
    description: 'Charitable organizations, NGOs', color: '#8b5cf6',
    subcategories: ['Advocacy', 'Awareness Campaign', 'Charity Event', 'Community Outreach', 'Disaster Relief', 'Food Security', 'Fundraiser', 'Healthcare Access', 'Human Rights', 'Humanitarian Aid', 'NGO Support', 'Poverty Alleviation', 'Social Justice', 'Water & Sanitation']
  },
  { 
    id: 'sports', name: 'Sports & Teams', icon: 'Trophy', 
    description: 'Equipment, travel, tournaments', color: '#22c55e',
    subcategories: ['Athletics', 'Badminton', 'Baseball', 'Basketball', 'Boxing', 'Cricket', 'Cycling', 'Football', 'Golf', 'Gymnastics', 'Hockey', 'Martial Arts', 'Rugby', 'Running', 'Skating', 'Skiing', 'Soccer', 'Swimming', 'Table Tennis', 'Team Equipment', 'Tennis', 'Tournament Travel', 'Volleyball', 'Wrestling']
  },
  { 
    id: 'environment', name: 'Environment & Nature', icon: 'Microscope', 
    description: 'Conservation, clean-up, wildlife', color: '#10b981',
    subcategories: ['Beach Cleanup', 'Carbon Offset', 'Climate Action', 'Conservation', 'Ecosystem Restoration', 'Environmental Education', 'Green Energy', 'Ocean Conservation', 'Plastic Reduction', 'Rainforest Protection', 'Recycling Initiative', 'Reforestation', 'Sustainable Agriculture', 'Tree Planting', 'Wildlife Protection']
  },
  { 
    id: 'family', name: 'Family & Children', icon: 'Users', 
    description: 'Adoption, childcare, family support', color: '#f472b6',
    subcategories: ['Adoption', 'Baby Supplies', 'Childcare', 'Children Welfare', 'Custody Battle', 'Family Reunion', 'Family Support', 'Foster Care', 'IVF/Fertility', 'Newborn Care', 'Orphan Support', 'Parenting Resources', 'Single Parent Support', 'Special Needs Child']
  },
  { 
    id: 'faith', name: 'Faith & Religion', icon: 'Building2', 
    description: 'Church, mosque, temple, spiritual', color: '#a855f7',
    subcategories: ['Buddhist Temple', 'Church', 'Church Renovation', 'Gurdwara', 'Hindu Temple', 'Mission Trip', 'Mosque', 'Religious Education', 'Religious Event', 'Spiritual Retreat', 'Synagogue', 'Youth Ministry']
  },
  { 
    id: 'volunteer', name: 'Volunteer & Service', icon: 'Heart', 
    description: 'Mission trips, humanitarian work', color: '#06b6d4',
    subcategories: ['Community Service', 'Disaster Response', 'Environmental Volunteer', 'Healthcare Volunteer', 'Humanitarian Work', 'International Aid', 'Medical Mission', 'Mission Trip', 'Peace Corps', 'Teaching Abroad', 'Volunteer Project', 'Youth Volunteer']
  },
  { 
    id: 'housing', name: 'Housing & Shelter', icon: 'Building2', 
    description: 'Rent assistance, homelessness', color: '#eab308',
    subcategories: ['Accessibility Modifications', 'Down Payment', 'Emergency Housing', 'First Home', 'Home Repair', 'Homelessness', 'Mobile Home', 'Mortgage Assistance', 'Moving Expenses', 'Rent Assistance', 'Security Deposit', 'Shelter Support', 'Transitional Housing', 'Utilities Assistance']
  },
  { 
    id: 'legal', name: 'Legal & Justice', icon: 'Building2', 
    description: 'Legal fees, advocacy, rights', color: '#64748b',
    subcategories: ['Advocacy', 'Bail Fund', 'Child Custody', 'Civil Rights', 'Criminal Defense', 'Discrimination Case', 'Divorce', 'Immigration', 'Innocence Project', 'Justice Reform', 'Legal Fees', 'Wrongful Conviction']
  },
  { 
    id: 'mental-health', name: 'Mental Health', icon: 'Heart', 
    description: 'Counseling, therapy, awareness', color: '#c084fc',
    subcategories: ['Addiction Recovery', 'Anxiety Treatment', 'Awareness Campaign', 'Counseling', 'Crisis Intervention', 'Depression Treatment', 'Eating Disorder', 'Grief Support', 'PTSD Treatment', 'Recovery Program', 'Rehab', 'Stress Management', 'Support Group', 'Therapy', 'Trauma Recovery']
  },
  { 
    id: 'disability', name: 'Disability Support', icon: 'Heart', 
    description: 'Accessibility, equipment, care', color: '#2dd4bf',
    subcategories: ['Accessibility Modifications', 'Assistive Technology', 'Autism Support', 'Blindness/Vision', 'Care Services', 'Deafness/Hearing', 'Home Modifications', 'Learning Disability', 'Mobility Aids', 'Physical Disability', 'Prosthetics', 'Service Dog', 'Special Needs', 'Therapy', 'Wheelchair']
  },
];

// Project Categories - For creators building awesome stuff
export const projectCategories = [
  { 
    id: 'tech', name: 'Technology & Gadgets', icon: 'Rocket', 
    description: 'Hardware, IoT, Electronics, Robotics', color: '#3b82f6',
    subcategories: ['Hardware', 'IoT Devices', 'Electronics', 'Robotics', 'Drones', 'Wearable Tech', '3D Printing', 'Smart Home', 'Arduino/Raspberry Pi', 'Green Tech']
  },
  { 
    id: 'software', name: 'Software & Apps', icon: 'Building2', 
    description: 'Mobile apps, Web platforms, SaaS', color: '#8b5cf6',
    subcategories: ['Mobile Apps', 'Web Apps', 'SaaS', 'AI/ML Tools', 'Productivity Tools', 'Social Platforms', 'Developer Tools', 'Browser Extensions', 'APIs', 'Open Source']
  },
  { 
    id: 'games', name: 'Games & Gaming', icon: 'Trophy', 
    description: 'Video games, Board games, VR/AR', color: '#ef4444',
    subcategories: ['Video Games', 'Board Games', 'Card Games', 'VR Games', 'AR Games', 'Mobile Games', 'Indie Games', 'RPG', 'Action/Adventure', 'Puzzle Games', 'Esports']
  },
  { 
    id: 'art', name: 'Art & Illustration', icon: 'Heart', 
    description: 'Digital art, NFTs, Graphic design', color: '#ec4899',
    subcategories: ['Digital Art', 'NFTs', 'Graphic Design', 'Illustration', 'Animation Art', 'Concept Art', 'Character Design', 'Comic Art', 'Fine Art', 'Street Art']
  },
  { 
    id: 'film', name: 'Film & Video', icon: 'Users', 
    description: 'Movies, Documentaries, Animation', color: '#f97316',
    subcategories: ['Feature Film', 'Short Film', 'Documentary', 'Animation', 'Web Series', 'Music Video', 'YouTube Content', 'Commercial', 'Film Festival', 'Post-Production']
  },
  { 
    id: 'music', name: 'Music & Audio', icon: 'Heart', 
    description: 'Albums, Podcasts, Sound design', color: '#06b6d4',
    subcategories: ['Album Recording', 'Single Release', 'Podcast', 'Sound Design', 'Music Production', 'Live Performance', 'Music Video', 'Audio Equipment', 'Studio Setup', 'Music Education']
  },
  { 
    id: 'publishing', name: 'Writing & Publishing', icon: 'GraduationCap', 
    description: 'Books, Comics, Magazines', color: '#14b8a6',
    subcategories: ['Novel', 'Non-Fiction', 'Comic Book', 'Graphic Novel', 'Magazine', 'Poetry', 'Audiobook', 'E-Book', 'Anthology', 'Zine', 'Translation']
  },
  { 
    id: 'fashion', name: 'Fashion & Wearables', icon: 'Users', 
    description: 'Clothing, Accessories, Jewelry', color: '#f472b6',
    subcategories: ['Clothing Line', 'Accessories', 'Jewelry', 'Footwear', 'Bags', 'Sustainable Fashion', 'Streetwear', 'Luxury Fashion', 'Athletic Wear', 'Kids Fashion']
  },
  { 
    id: 'photography', name: 'Photography', icon: 'Heart', 
    description: 'Photo projects, Exhibitions', color: '#84cc16',
    subcategories: ['Photo Book', 'Exhibition', 'Documentary Photography', 'Portrait Project', 'Landscape Photography', 'Street Photography', 'Photo Equipment', 'Photo Studio', 'Workshop', 'Archive Project']
  },
  { 
    id: 'crafts', name: 'Crafts & DIY', icon: 'Building2', 
    description: 'Handmade goods, Maker projects', color: '#eab308',
    subcategories: ['Woodworking', 'Ceramics', 'Textiles', 'Leatherwork', 'Metalwork', 'Paper Crafts', 'Candles/Soap', 'Knitting/Crochet', 'Embroidery', 'Upcycling']
  },
  { 
    id: 'food', name: 'Food & Beverages', icon: 'Heart', 
    description: 'Restaurants, Food products, Recipes', color: '#22c55e',
    subcategories: ['Restaurant', 'Food Truck', 'Bakery', 'Brewery', 'Coffee Shop', 'Food Product', 'Cookbook', 'Specialty Food', 'Vegan/Vegetarian', 'Meal Delivery']
  },
  { 
    id: 'product', name: 'Product Design', icon: 'Rocket', 
    description: 'Consumer products, Industrial design', color: '#64748b',
    subcategories: ['Consumer Product', 'Industrial Design', 'Furniture', 'Home Goods', 'Office Products', 'Sports Equipment', 'Travel Gear', 'Pet Products', 'Kids Products', 'Eco Products']
  },
  { 
    id: 'architecture', name: 'Architecture & Spaces', icon: 'Building2', 
    description: 'Buildings, Interior design', color: '#a855f7',
    subcategories: ['Residential', 'Commercial', 'Interior Design', 'Landscape', 'Sustainable Architecture', 'Public Spaces', 'Renovation', 'Historic Preservation', 'Urban Design', 'Tiny Homes']
  },
  { 
    id: 'theater', name: 'Dance & Theater', icon: 'Users', 
    description: 'Performances, Productions, Shows', color: '#c084fc',
    subcategories: ['Theater Production', 'Musical', 'Dance Performance', 'Opera', 'Comedy Show', 'Drama', 'Experimental', 'Street Performance', 'Festival', 'Workshop']
  },
  { 
    id: 'education', name: 'Courses & Tutorials', icon: 'GraduationCap', 
    description: 'Online courses, E-learning', color: '#2dd4bf',
    subcategories: ['Online Course', 'Video Tutorial', 'Workshop Series', 'Bootcamp', 'Certification Program', 'Language Learning', 'Skills Training', 'Academic Course', 'Kids Education', 'Professional Development']
  },
  { 
    id: 'science', name: 'Science & Research', icon: 'Microscope', 
    description: 'Experiments, Studies, Innovation', color: '#10b981',
    subcategories: ['Medical Research', 'Environmental Study', 'Technology Research', 'Social Science', 'Space Exploration', 'Biology', 'Physics', 'Chemistry', 'Psychology', 'Citizen Science']
  },
];

export const featuredCampaigns = [
  {
    id: '1',
    title: "Help Sarah Beat Cancer",
    creator: { name: 'Michael Thompson', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Sarah Thompson',
    category: 'medical',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&h=500&fit=crop',
    goal: 150000,
    raised: 127850,
    donors: 2847,
    daysLeft: 12,
    location: 'Boston, MA',
    verified: true,
    milestone: { current: 3, total: 4, name: 'Chemotherapy Phase 2' },
    story: 'Sarah was diagnosed with stage 3 breast cancer in January. Your support helps cover treatment costs at Dana-Farber Cancer Institute.',
    updates: 8,
    trending: true,
    escrow: true,
  },
  {
    id: '2',
    title: "Rebuild Honduras School After Hurricane",
    creator: { name: 'Maria Rodriguez', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Escuela Primaria San José',
    category: 'nonprofit',
    image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&h=500&fit=crop',
    goal: 85000,
    raised: 62340,
    donors: 1523,
    daysLeft: 28,
    location: 'Tegucigalpa, Honduras',
    verified: true,
    milestone: { current: 2, total: 5, name: 'Foundation Complete' },
    story: 'Hurricane Mitch destroyed our school serving 450 children. Help us rebuild and provide a safe learning environment.',
    updates: 12,
    trending: true,
    escrow: true,
  },
  {
    id: '3',
    title: "Olympic Dreams: Support Team USA Swimmer",
    creator: { name: 'David Chen', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Self',
    category: 'sports',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800&h=500&fit=crop',
    goal: 45000,
    raised: 38920,
    donors: 892,
    daysLeft: 45,
    location: 'San Diego, CA',
    verified: true,
    milestone: { current: 2, total: 3, name: 'Training Camp Funded' },
    story: 'Help me pursue my Olympic dream in swimming. Funds cover training, coaching, and competition travel expenses.',
    updates: 5,
    trending: false,
    escrow: false,
  },
  {
    id: '4',
    title: "Revolutionary Cancer Detection Research",
    creator: { name: 'Dr. Emily Watson', avatar: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Stanford Medical Research Lab',
    category: 'research',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&h=500&fit=crop',
    goal: 250000,
    raised: 189500,
    donors: 3241,
    daysLeft: 60,
    location: 'Palo Alto, CA',
    verified: true,
    milestone: { current: 4, total: 6, name: 'Clinical Trials Phase' },
    story: 'Our lab developed a breakthrough early cancer detection method. Help fund clinical trials to bring this to patients worldwide.',
    updates: 15,
    trending: true,
    escrow: true,
  },
  {
    id: '5',
    title: "Emergency Relief: Turkey Earthquake Survivors",
    creator: { name: 'Red Crescent Foundation', avatar: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Affected Families in Hatay',
    category: 'emergency',
    image: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=800&h=500&fit=crop',
    goal: 500000,
    raised: 423150,
    donors: 8934,
    daysLeft: 5,
    location: 'Hatay, Turkey',
    verified: true,
    milestone: { current: 3, total: 4, name: 'Shelter Distribution' },
    story: 'Providing emergency shelter, food, and medical supplies to families affected by the devastating earthquake.',
    updates: 25,
    trending: true,
    escrow: true,
  },
  {
    id: '6',
    title: "First-Generation Student Scholarship Fund",
    creator: { name: 'Dreams Foundation', avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop', verified: true },
    beneficiary: 'Multiple Students',
    category: 'education',
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=500&fit=crop',
    goal: 100000,
    raised: 78600,
    donors: 1876,
    daysLeft: 90,
    location: 'Nationwide, USA',
    verified: true,
    milestone: { current: 2, total: 4, name: '15 Scholarships Awarded' },
    story: 'Supporting first-generation college students with tuition, books, and living expenses to achieve their educational dreams.',
    updates: 10,
    trending: false,
    escrow: true,
  },
];

export const recentDonations = [
  { id: 1, donor: 'Anonymous', amount: 500, campaign: "Help Sarah Beat Cancer", time: '2 minutes ago', message: 'Stay strong Sarah!' },
  { id: 2, donor: 'John D.', amount: 100, campaign: 'Rebuild Honduras School', time: '5 minutes ago', message: 'For the children' },
  { id: 3, donor: 'Emily R.', amount: 250, campaign: 'Cancer Detection Research', time: '8 minutes ago', message: null },
  { id: 4, donor: 'Tech Corp Inc.', amount: 5000, campaign: 'Emergency Relief Turkey', time: '12 minutes ago', message: 'Our company stands with you' },
  { id: 5, donor: 'Anonymous', amount: 50, campaign: 'Olympic Dreams', time: '15 minutes ago', message: 'Go Team USA!' },
];

export const successStories = [
  {
    id: 1,
    title: 'Community Garden Transforms Neighborhood',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&h=400&fit=crop',
    raised: 25000,
    impact: '200 families now have fresh produce',
    quote: 'This garden changed our community forever.',
  },
  {
    id: 2,
    title: 'Medical Treatment Saves Young Mother',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&h=400&fit=crop',
    raised: 180000,
    impact: 'Full recovery after life-saving surgery',
    quote: 'I can watch my children grow up thanks to your generosity.',
  },
  {
    id: 3,
    title: 'Scholarship Recipient Graduates Top of Class',
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&h=400&fit=crop',
    raised: 45000,
    impact: 'First in family to earn university degree',
    quote: 'You believed in me when no one else did.',
  },
];

export const platformStats = {
  totalRaised: 'Millions',
  totalDonors: 'Thousands',
  totalCampaigns: 'Thousands',
  countriesReached: 'Global',
  successRate: 'High',
  avgResponseTime: '24h',
};

export const testimonials = [
  {
    id: 1,
    name: 'Jennifer Martinez',
    role: 'Campaign Creator',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    text: 'The milestone feature helped donors see exactly where their money was going. We reached our goal in just 3 weeks!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Robert Chen',
    role: 'Regular Donor',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    text: 'I love the transparency features. The campaign updates and verification badges help me feel informed about where my donations are going.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Sarah Williams',
    role: 'Non-Profit Director',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
    text: 'The verification process was thorough but quick. Our donors trust us more because of the platform badges.',
    rating: 5,
  },
];

export const userProfile = {
  id: 'user-1',
  name: 'Alex Johnson',
  email: 'alex.johnson@email.com',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  verified: true,
  verificationLevel: 'enhanced',
  joinedDate: '2023-06-15',
  location: 'New York, NY',
  totalDonated: 12500,
  totalRaised: 85000,
  campaignsCreated: 3,
  campaignsDonatedTo: 47,
  badges: ['early_adopter', 'verified_identity', 'top_donor', 'trusted_creator'],
};

export const donationHistory = [
  { id: 1, campaign: "Help Sarah Beat Cancer", amount: 500, date: '2024-01-15', status: 'completed', receipt: true },
  { id: 2, campaign: 'Rebuild Honduras School', amount: 250, date: '2024-01-10', status: 'completed', receipt: true },
  { id: 3, campaign: 'Cancer Detection Research', amount: 1000, date: '2024-01-05', status: 'completed', receipt: true },
  { id: 4, campaign: 'Emergency Relief Turkey', amount: 300, date: '2024-01-02', status: 'completed', receipt: true },
];

export const myCampaigns = [
  {
    id: 'my-1',
    title: 'Community Youth Center Renovation',
    type: 'campaign',
    status: 'active',
    goal: 75000,
    raised: 42500,
    donors: 234,
    daysLeft: 30,
    image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=400&h=250&fit=crop',
    updates: 5,
    pendingPayouts: 15000,
    milestone: { current: 2, total: 4 },
  },
  {
    id: 'my-2',
    title: 'Help Sarah Beat Cancer - Treatment Fund',
    type: 'campaign',
    status: 'active',
    goal: 150000,
    raised: 127850,
    donors: 2847,
    daysLeft: 12,
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop',
    updates: 12,
    pendingPayouts: 45000,
    milestone: { current: 3, total: 4 },
  },
  {
    id: 'my-3',
    title: 'Local Animal Shelter Expansion',
    type: 'campaign',
    status: 'completed',
    goal: 50000,
    raised: 52300,
    donors: 456,
    daysLeft: 0,
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=400&h=250&fit=crop',
    updates: 8,
    pendingPayouts: 0,
    milestone: { current: 4, total: 4 },
  },
  {
    id: 'my-4',
    title: 'Scholarship Fund for Underprivileged Students',
    type: 'campaign',
    status: 'inactive',
    goal: 100000,
    raised: 35000,
    donors: 189,
    daysLeft: 0,
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=400&h=250&fit=crop',
    updates: 3,
    pendingPayouts: 10000,
    milestone: { current: 1, total: 3 },
  },
  {
    id: 'my-5',
    title: 'Emergency Flood Relief - Chennai',
    type: 'campaign',
    status: 'draft',
    goal: 80000,
    raised: 0,
    donors: 0,
    daysLeft: 30,
    image: 'https://images.unsplash.com/photo-1547683905-f686c993aae5?w=400&h=250&fit=crop',
    updates: 0,
    pendingPayouts: 0,
    milestone: { current: 0, total: 3 },
  },
  {
    id: 'proj-1',
    title: 'Open Source Learning Platform',
    type: 'project',
    status: 'active',
    goal: 25000,
    raised: 12500,
    donors: 156,
    daysLeft: 45,
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=400&h=250&fit=crop',
    updates: 4,
    pendingPayouts: 5000,
    milestone: { current: 1, total: 3 },
  },
  {
    id: 'proj-2',
    title: 'Community Garden Project',
    type: 'project',
    status: 'draft',
    goal: 15000,
    raised: 0,
    donors: 0,
    daysLeft: 60,
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=250&fit=crop',
    updates: 0,
    pendingPayouts: 0,
    milestone: { current: 0, total: 2 },
  },
];

export const notifications = [
  { id: 1, type: 'donation', message: 'Anonymous donated $500 to your campaign', time: '5 min ago', read: false },
  { id: 2, type: 'milestone', message: 'Milestone 2 has been approved!', time: '1 hour ago', read: false },
  { id: 3, type: 'update', message: 'Your campaign update was posted', time: '2 hours ago', read: true },
  { id: 4, type: 'verification', message: 'Your identity verification is complete', time: '1 day ago', read: true },
];

export const campaignCategories = [
  'Medical & Health',
  'Education & Learning',
  'Emergency & Disaster',
  'Non-Profit & Charity',
  'Sports & Athletics',
  'Research & Innovation',
  'Startup & Business',
  'Community & Local',
  'Animals & Pets',
  'Environment & Nature',
  'Arts & Creative',
  'Memorial & Tribute',
];

export const countries = [
  { code: 'US', name: 'United States' },
  { code: 'UK', name: 'United Kingdom' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'JP', name: 'Japan' },
  { code: 'SG', name: 'Singapore' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'IN', name: 'India' },
  { code: 'CN', name: 'China' },
  { code: 'BR', name: 'Brazil' },
  { code: 'MX', name: 'Mexico' },
  { code: 'IT', name: 'Italy' },
  { code: 'ES', name: 'Spain' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'BE', name: 'Belgium' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'AT', name: 'Austria' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'PL', name: 'Poland' },
  { code: 'IE', name: 'Ireland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'KR', name: 'South Korea' },
  { code: 'TH', name: 'Thailand' },
  { code: 'PH', name: 'Philippines' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'EG', name: 'Egypt' },
  { code: 'AR', name: 'Argentina' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'GR', name: 'Greece' },
  { code: 'RU', name: 'Russia' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'NP', name: 'Nepal' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'LA', name: 'Laos' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'IL', name: 'Israel' },
  { code: 'JO', name: 'Jordan' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'QA', name: 'Qatar' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'OM', name: 'Oman' },
  { code: 'MA', name: 'Morocco' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'KE', name: 'Kenya' },
  { code: 'GH', name: 'Ghana' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'UG', name: 'Uganda' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'PE', name: 'Peru' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'PA', name: 'Panama' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'HN', name: 'Honduras' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'HU', name: 'Hungary' },
  { code: 'RO', name: 'Romania' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'HR', name: 'Croatia' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LV', name: 'Latvia' },
  { code: 'EE', name: 'Estonia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'MT', name: 'Malta' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'IS', name: 'Iceland' },
];

// Comprehensive list of world currencies
export const currencies = [
  // Popular currencies (shown first)
  { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸', popular: true },
  { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺', popular: true },
  { code: 'GBP', symbol: '£', name: 'British Pound', flag: '🇬🇧', popular: true },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', flag: '🇯🇵', popular: true },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', flag: '🇨🇦', popular: true },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', flag: '🇦🇺', popular: true },
  { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc', flag: '🇨🇭', popular: true },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', flag: '🇨🇳', popular: true },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', flag: '🇮🇳', popular: true },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', flag: '🇸🇬', popular: true },
  // A
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', flag: '🇦🇪' },
  { code: 'AFN', symbol: '؋', name: 'Afghan Afghani', flag: '🇦🇫' },
  { code: 'ALL', symbol: 'L', name: 'Albanian Lek', flag: '🇦🇱' },
  { code: 'AMD', symbol: '֏', name: 'Armenian Dram', flag: '🇦🇲' },
  { code: 'ANG', symbol: 'ƒ', name: 'Netherlands Antillean Guilder', flag: '🇨🇼' },
  { code: 'AOA', symbol: 'Kz', name: 'Angolan Kwanza', flag: '🇦🇴' },
  { code: 'ARS', symbol: '$', name: 'Argentine Peso', flag: '🇦🇷' },
  { code: 'AWG', symbol: 'ƒ', name: 'Aruban Florin', flag: '🇦🇼' },
  { code: 'AZN', symbol: '₼', name: 'Azerbaijani Manat', flag: '🇦🇿' },
  // B
  { code: 'BAM', symbol: 'KM', name: 'Bosnia-Herzegovina Mark', flag: '🇧🇦' },
  { code: 'BBD', symbol: '$', name: 'Barbadian Dollar', flag: '🇧🇧' },
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', flag: '🇧🇩' },
  { code: 'BGN', symbol: 'лв', name: 'Bulgarian Lev', flag: '🇧🇬' },
  { code: 'BHD', symbol: '.د.ب', name: 'Bahraini Dinar', flag: '🇧🇭' },
  { code: 'BIF', symbol: 'FBu', name: 'Burundian Franc', flag: '🇧🇮' },
  { code: 'BMD', symbol: '$', name: 'Bermudian Dollar', flag: '🇧🇲' },
  { code: 'BND', symbol: '$', name: 'Brunei Dollar', flag: '🇧🇳' },
  { code: 'BOB', symbol: 'Bs.', name: 'Bolivian Boliviano', flag: '🇧🇴' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', flag: '🇧🇷' },
  { code: 'BSD', symbol: '$', name: 'Bahamian Dollar', flag: '🇧🇸' },
  { code: 'BTN', symbol: 'Nu.', name: 'Bhutanese Ngultrum', flag: '🇧🇹' },
  { code: 'BWP', symbol: 'P', name: 'Botswanan Pula', flag: '🇧🇼' },
  { code: 'BYN', symbol: 'Br', name: 'Belarusian Ruble', flag: '🇧🇾' },
  { code: 'BZD', symbol: 'BZ$', name: 'Belize Dollar', flag: '🇧🇿' },
  // C
  { code: 'CDF', symbol: 'FC', name: 'Congolese Franc', flag: '🇨🇩' },
  { code: 'CLP', symbol: '$', name: 'Chilean Peso', flag: '🇨🇱' },
  { code: 'COP', symbol: '$', name: 'Colombian Peso', flag: '🇨🇴' },
  { code: 'CRC', symbol: '₡', name: 'Costa Rican Colón', flag: '🇨🇷' },
  { code: 'CUP', symbol: '₱', name: 'Cuban Peso', flag: '🇨🇺' },
  { code: 'CVE', symbol: '$', name: 'Cape Verdean Escudo', flag: '🇨🇻' },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', flag: '🇨🇿' },
  // D
  { code: 'DJF', symbol: 'Fdj', name: 'Djiboutian Franc', flag: '🇩🇯' },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone', flag: '🇩🇰' },
  { code: 'DOP', symbol: 'RD$', name: 'Dominican Peso', flag: '🇩🇴' },
  { code: 'DZD', symbol: 'د.ج', name: 'Algerian Dinar', flag: '🇩🇿' },
  // E
  { code: 'EGP', symbol: '£', name: 'Egyptian Pound', flag: '🇪🇬' },
  { code: 'ERN', symbol: 'Nfk', name: 'Eritrean Nakfa', flag: '🇪🇷' },
  { code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr', flag: '🇪🇹' },
  // F
  { code: 'FJD', symbol: '$', name: 'Fijian Dollar', flag: '🇫🇯' },
  { code: 'FKP', symbol: '£', name: 'Falkland Islands Pound', flag: '🇫🇰' },
  // G
  { code: 'GEL', symbol: '₾', name: 'Georgian Lari', flag: '🇬🇪' },
  { code: 'GHS', symbol: '₵', name: 'Ghanaian Cedi', flag: '🇬🇭' },
  { code: 'GIP', symbol: '£', name: 'Gibraltar Pound', flag: '🇬🇮' },
  { code: 'GMD', symbol: 'D', name: 'Gambian Dalasi', flag: '🇬🇲' },
  { code: 'GNF', symbol: 'FG', name: 'Guinean Franc', flag: '🇬🇳' },
  { code: 'GTQ', symbol: 'Q', name: 'Guatemalan Quetzal', flag: '🇬🇹' },
  { code: 'GYD', symbol: '$', name: 'Guyanese Dollar', flag: '🇬🇾' },
  // H
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar', flag: '🇭🇰' },
  { code: 'HNL', symbol: 'L', name: 'Honduran Lempira', flag: '🇭🇳' },
  { code: 'HRK', symbol: 'kn', name: 'Croatian Kuna', flag: '🇭🇷' },
  { code: 'HTG', symbol: 'G', name: 'Haitian Gourde', flag: '🇭🇹' },
  { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint', flag: '🇭🇺' },
  // I
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', flag: '🇮🇩' },
  { code: 'ILS', symbol: '₪', name: 'Israeli New Shekel', flag: '🇮🇱' },
  { code: 'IQD', symbol: 'ع.د', name: 'Iraqi Dinar', flag: '🇮🇶' },
  { code: 'IRR', symbol: '﷼', name: 'Iranian Rial', flag: '🇮🇷' },
  { code: 'ISK', symbol: 'kr', name: 'Icelandic Króna', flag: '🇮🇸' },
  // J
  { code: 'JMD', symbol: 'J$', name: 'Jamaican Dollar', flag: '🇯🇲' },
  { code: 'JOD', symbol: 'د.ا', name: 'Jordanian Dinar', flag: '🇯🇴' },
  // K
  { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', flag: '🇰🇪' },
  { code: 'KGS', symbol: 'лв', name: 'Kyrgystani Som', flag: '🇰🇬' },
  { code: 'KHR', symbol: '៛', name: 'Cambodian Riel', flag: '🇰🇭' },
  { code: 'KMF', symbol: 'CF', name: 'Comorian Franc', flag: '🇰🇲' },
  { code: 'KPW', symbol: '₩', name: 'North Korean Won', flag: '🇰🇵' },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won', flag: '🇰🇷' },
  { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar', flag: '🇰🇼' },
  { code: 'KYD', symbol: '$', name: 'Cayman Islands Dollar', flag: '🇰🇾' },
  { code: 'KZT', symbol: '₸', name: 'Kazakhstani Tenge', flag: '🇰🇿' },
  // L
  { code: 'LAK', symbol: '₭', name: 'Laotian Kip', flag: '🇱🇦' },
  { code: 'LBP', symbol: 'ل.ل', name: 'Lebanese Pound', flag: '🇱🇧' },
  { code: 'LKR', symbol: '₨', name: 'Sri Lankan Rupee', flag: '🇱🇰' },
  { code: 'LRD', symbol: '$', name: 'Liberian Dollar', flag: '🇱🇷' },
  { code: 'LSL', symbol: 'L', name: 'Lesotho Loti', flag: '🇱🇸' },
  { code: 'LYD', symbol: 'ل.د', name: 'Libyan Dinar', flag: '🇱🇾' },
  // M
  { code: 'MAD', symbol: 'د.م.', name: 'Moroccan Dirham', flag: '🇲🇦' },
  { code: 'MDL', symbol: 'L', name: 'Moldovan Leu', flag: '🇲🇩' },
  { code: 'MGA', symbol: 'Ar', name: 'Malagasy Ariary', flag: '🇲🇬' },
  { code: 'MKD', symbol: 'ден', name: 'Macedonian Denar', flag: '🇲🇰' },
  { code: 'MMK', symbol: 'K', name: 'Myanmar Kyat', flag: '🇲🇲' },
  { code: 'MNT', symbol: '₮', name: 'Mongolian Tugrik', flag: '🇲🇳' },
  { code: 'MOP', symbol: 'MOP$', name: 'Macanese Pataca', flag: '🇲🇴' },
  { code: 'MRU', symbol: 'UM', name: 'Mauritanian Ouguiya', flag: '🇲🇷' },
  { code: 'MUR', symbol: '₨', name: 'Mauritian Rupee', flag: '🇲🇺' },
  { code: 'MVR', symbol: 'Rf', name: 'Maldivian Rufiyaa', flag: '🇲🇻' },
  { code: 'MWK', symbol: 'MK', name: 'Malawian Kwacha', flag: '🇲🇼' },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso', flag: '🇲🇽' },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', flag: '🇲🇾' },
  { code: 'MZN', symbol: 'MT', name: 'Mozambican Metical', flag: '🇲🇿' },
  // N
  { code: 'NAD', symbol: '$', name: 'Namibian Dollar', flag: '🇳🇦' },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', flag: '🇳🇬' },
  { code: 'NIO', symbol: 'C$', name: 'Nicaraguan Córdoba', flag: '🇳🇮' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', flag: '🇳🇴' },
  { code: 'NPR', symbol: '₨', name: 'Nepalese Rupee', flag: '🇳🇵' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', flag: '🇳🇿' },
  // O
  { code: 'OMR', symbol: 'ر.ع.', name: 'Omani Rial', flag: '🇴🇲' },
  // P
  { code: 'PAB', symbol: 'B/.', name: 'Panamanian Balboa', flag: '🇵🇦' },
  { code: 'PEN', symbol: 'S/.', name: 'Peruvian Sol', flag: '🇵🇪' },
  { code: 'PGK', symbol: 'K', name: 'Papua New Guinean Kina', flag: '🇵🇬' },
  { code: 'PHP', symbol: '₱', name: 'Philippine Peso', flag: '🇵🇭' },
  { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee', flag: '🇵🇰' },
  { code: 'PLN', symbol: 'zł', name: 'Polish Zloty', flag: '🇵🇱' },
  { code: 'PYG', symbol: '₲', name: 'Paraguayan Guarani', flag: '🇵🇾' },
  // Q
  { code: 'QAR', symbol: 'ر.ق', name: 'Qatari Rial', flag: '🇶🇦' },
  // R
  { code: 'RON', symbol: 'lei', name: 'Romanian Leu', flag: '🇷🇴' },
  { code: 'RSD', symbol: 'дин.', name: 'Serbian Dinar', flag: '🇷🇸' },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble', flag: '🇷🇺' },
  { code: 'RWF', symbol: 'FRw', name: 'Rwandan Franc', flag: '🇷🇼' },
  // S
  { code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal', flag: '🇸🇦' },
  { code: 'SBD', symbol: '$', name: 'Solomon Islands Dollar', flag: '🇸🇧' },
  { code: 'SCR', symbol: '₨', name: 'Seychellois Rupee', flag: '🇸🇨' },
  { code: 'SDG', symbol: 'ج.س.', name: 'Sudanese Pound', flag: '🇸🇩' },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', flag: '🇸🇪' },
  { code: 'SHP', symbol: '£', name: 'Saint Helena Pound', flag: '🇸🇭' },
  { code: 'SLL', symbol: 'Le', name: 'Sierra Leonean Leone', flag: '🇸🇱' },
  { code: 'SOS', symbol: 'S', name: 'Somali Shilling', flag: '🇸🇴' },
  { code: 'SRD', symbol: '$', name: 'Surinamese Dollar', flag: '🇸🇷' },
  { code: 'SSP', symbol: '£', name: 'South Sudanese Pound', flag: '🇸🇸' },
  { code: 'STN', symbol: 'Db', name: 'São Tomé and Príncipe Dobra', flag: '🇸🇹' },
  { code: 'SYP', symbol: '£', name: 'Syrian Pound', flag: '🇸🇾' },
  { code: 'SZL', symbol: 'L', name: 'Swazi Lilangeni', flag: '🇸🇿' },
  // T
  { code: 'THB', symbol: '฿', name: 'Thai Baht', flag: '🇹🇭' },
  { code: 'TJS', symbol: 'SM', name: 'Tajikistani Somoni', flag: '🇹🇯' },
  { code: 'TMT', symbol: 'T', name: 'Turkmenistani Manat', flag: '🇹🇲' },
  { code: 'TND', symbol: 'د.ت', name: 'Tunisian Dinar', flag: '🇹🇳' },
  { code: 'TOP', symbol: 'T$', name: 'Tongan Paʻanga', flag: '🇹🇴' },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira', flag: '🇹🇷' },
  { code: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago Dollar', flag: '🇹🇹' },
  { code: 'TWD', symbol: 'NT$', name: 'New Taiwan Dollar', flag: '🇹🇼' },
  { code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling', flag: '🇹🇿' },
  // U
  { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia', flag: '🇺🇦' },
  { code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling', flag: '🇺🇬' },
  { code: 'UYU', symbol: '$U', name: 'Uruguayan Peso', flag: '🇺🇾' },
  { code: 'UZS', symbol: 'лв', name: 'Uzbekistani Som', flag: '🇺🇿' },
  // V
  { code: 'VES', symbol: 'Bs.S', name: 'Venezuelan Bolívar', flag: '🇻🇪' },
  { code: 'VND', symbol: '₫', name: 'Vietnamese Dong', flag: '🇻🇳' },
  { code: 'VUV', symbol: 'VT', name: 'Vanuatu Vatu', flag: '🇻🇺' },
  // W
  { code: 'WST', symbol: 'WS$', name: 'Samoan Tala', flag: '🇼🇸' },
  // X
  { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc', flag: '🌍' },
  { code: 'XCD', symbol: '$', name: 'East Caribbean Dollar', flag: '🌎' },
  { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc', flag: '🌍' },
  { code: 'XPF', symbol: '₣', name: 'CFP Franc', flag: '🌏' },
  // Y
  { code: 'YER', symbol: '﷼', name: 'Yemeni Rial', flag: '🇾🇪' },
  // Z
  { code: 'ZAR', symbol: 'R', name: 'South African Rand', flag: '🇿🇦' },
  { code: 'ZMW', symbol: 'ZK', name: 'Zambian Kwacha', flag: '🇿🇲' },
  { code: 'ZWL', symbol: 'Z$', name: 'Zimbabwean Dollar', flag: '🇿🇼' },
];
